(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (err) {
      return null;
    }
  }

  function normalizePlatform(value) {
    var key = String(value || '').trim().toLowerCase();
    if (key === 'x') return 'twitter';
    if (key === 'website' || key === 'www') return 'web';
    return key;
  }

  function starsHtml(rating) {
    var n = Math.max(0, Math.min(5, parseInt(rating, 10) || 0));
    var out = '';
    for (var i = 1; i <= 5; i += 1) {
      out += i <= n ? '&#9733;' : '&#9734;';
    }
    return out;
  }

  function resolveHref(item, profiles) {
    if (item.source_url) return item.source_url;
    var platform = normalizePlatform(item.platform);
    return (profiles && profiles[platform]) || '';
  }

  function mergeReviews(blocks, jsonReviews) {
    var map = {};
    (jsonReviews || []).forEach(function (item) {
      if (!item || !item.id) return;
      map[item.id] = item;
    });
    (blocks || []).forEach(function (item) {
      if (!item || !item.id) return;
      map[item.id] = item;
    });
    return Object.keys(map)
      .map(function (key) {
        return map[key];
      })
      .filter(function (item) {
        return item.review && String(item.review).trim() !== '';
      });
  }

  function renderCard(item, config) {
    var platform = normalizePlatform(item.platform);
    var platformLabels = (config.labels && config.labels.platforms) || {};
    var platformLabel = platformLabels[platform] || platform;
    var iconSrc = (config.icons && config.icons[platform]) || '';
    var href = resolveHref(item, config.platformProfiles);
    var demoBadge = config.labels && config.labels.demoBadge;
    var viewLabel = (config.labels && config.labels.viewReview) || 'View original review';
    var username = item.username || '';
    var product = item.product || '';
    var date = item.date || '';
    var image = item.image || '';
    var rating = item.rating || 0;

    var card = document.createElement('article');
    card.className = 'smr-crv-card';
    card.setAttribute('role', 'listitem');
    card.setAttribute('data-platform', platform);
    if (item.is_demo) card.setAttribute('data-demo', 'true');

    var inner = document.createElement('div');
    inner.className = 'smr-crv-card__inner';

    var head = document.createElement('header');
    head.className = 'smr-crv-card__head';
    head.innerHTML =
      '<span class="smr-crv-card__platform" aria-hidden="true">' +
      (iconSrc ? '<img src="' + escapeHtml(iconSrc) + '" alt="" width="18" height="18" loading="lazy">' : '') +
      '</span>' +
      '<span class="smr-crv-card__platform-name">' +
      escapeHtml(platformLabel) +
      '</span>' +
      (username ? '<span class="smr-crv-card__user">' + escapeHtml(username) + '</span>' : '');

    inner.appendChild(head);

    if (item.is_demo && demoBadge) {
      var badge = document.createElement('p');
      badge.className = 'smr-crv-card__demo';
      badge.textContent = demoBadge;
      inner.appendChild(badge);
    }

    if (rating > 0) {
      var stars = document.createElement('p');
      stars.className = 'smr-crv-card__stars';
      var ratingTpl = (config.labels && config.labels.ratingAria) || '{{ rating }} out of 5 stars';
      stars.setAttribute('aria-label', String(ratingTpl).replace('{{ rating }}', String(rating)).replace('__RATING__', String(rating)));
      stars.innerHTML = starsHtml(rating);
      inner.appendChild(stars);
    }

    var review = document.createElement('p');
    review.className = 'smr-crv-card__review';
    review.setAttribute('data-smr-crv-review', '');
    review.setAttribute('tabindex', '0');
    review.setAttribute('role', 'button');
    review.textContent = item.review;
    inner.appendChild(review);

    if (image) {
      var media = document.createElement('div');
      media.className = 'smr-crv-card__media';
      media.innerHTML =
        '<img src="' +
        escapeHtml(image) +
        '" alt="" loading="lazy" decoding="async" width="640" height="360">';
      inner.appendChild(media);
    }

    var meta = document.createElement('footer');
    meta.className = 'smr-crv-card__meta';
    var metaBits = [];
    if (product) metaBits.push('<span class="smr-crv-card__product">' + escapeHtml(product) + '</span>');
    if (date) metaBits.push('<span class="smr-crv-card__date">' + escapeHtml(date) + '</span>');
    meta.innerHTML = metaBits.join('');
    inner.appendChild(meta);

    if (href) {
      var link = document.createElement('a');
      link.className = 'smr-crv-card__cta';
      link.href = href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.innerHTML = escapeHtml(viewLabel) + ' <span aria-hidden="true">&rarr;</span>';
      inner.appendChild(link);

      card.addEventListener('click', function (evt) {
        if (evt.target.closest('[data-smr-crv-review]')) return;
        if (evt.target.closest('a')) return;
        window.open(href, '_blank', 'noopener,noreferrer');
      });
      card.classList.add('smr-crv-card--linked');
    }

    card.appendChild(inner);
    return card;
  }

  function bindExpand(card, config) {
    var review = card.querySelector('[data-smr-crv-review]');
    if (!review) return;

    function syncExpandState() {
      var expanded = review.classList.contains('is-expanded');
      var overflow =
        !expanded &&
        (review.scrollHeight > review.clientHeight + 2 || review.textContent.length > 220);
      review.classList.toggle('is-truncatable', overflow || expanded);
      review.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      review.setAttribute(
        'aria-label',
        expanded
          ? (config.labels && config.labels.collapse) || 'Show less'
          : (config.labels && config.labels.expand) || 'Read more'
      );
    }

    function toggleExpand(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      review.classList.toggle('is-expanded');
      syncExpandState();
    }

    review.addEventListener('click', toggleExpand);
    review.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter' || evt.key === ' ') toggleExpand(evt);
    });

    window.requestAnimationFrame(syncExpandState);
    window.addEventListener('resize', syncExpandState);
  }

  function initSection(root) {
    if (!root || root.dataset.smrCrvReady === '1') return;
    root.dataset.smrCrvReady = '1';

    var config = readJson('smr-crv-config') || {};
    var blocks = readJson('smr-crv-blocks') || [];
    var grid = root.querySelector('[data-smr-crv-grid]');
    var empty = root.querySelector('[data-smr-crv-empty]');
    var moreBtn = root.querySelector('[data-smr-crv-more]');
    var moreWrap = root.querySelector('[data-smr-crv-more-wrap]');
    var allLoaded = root.querySelector('[data-smr-crv-all-loaded]');
    var filterWrap = root.querySelector('[data-smr-crv-platform-filters]');

    if (!grid) return;

    var allReviews = [];
    var filtered = [];
    var platform = 'all';
    var visibleCount = 0;
    var initialCount = parseInt(root.getAttribute('data-smr-crv-initial'), 10) || config.initialCount || 8;
    var loadBatch = parseInt(root.getAttribute('data-smr-crv-batch'), 10) || config.loadBatch || 6;

    function mobileInitial() {
      var w = window.innerWidth || 1200;
      if (w < 750) return Math.max(4, Math.min(6, initialCount - 2));
      return initialCount;
    }

    function renderVisible() {
      grid.innerHTML = '';
      var slice = filtered.slice(0, visibleCount);
      slice.forEach(function (item) {
        var card = renderCard(item, config);
        bindExpand(card, config);
        grid.appendChild(card);
      });

      var hasItems = filtered.length > 0;
      if (empty) empty.hidden = hasItems;
      grid.hidden = !hasItems;

      var allShown = visibleCount >= filtered.length;
      if (moreBtn) {
        moreBtn.hidden = !hasItems || allShown;
        moreBtn.disabled = allShown;
      }
      if (moreWrap) moreWrap.hidden = !hasItems;
      if (allLoaded) allLoaded.hidden = !hasItems || !allShown;
    }

    function applyFilter(nextPlatform, resetVisible) {
      platform = normalizePlatform(nextPlatform || 'all');
      filtered =
        platform === 'all'
          ? allReviews.slice()
          : allReviews.filter(function (item) {
              return normalizePlatform(item.platform) === platform;
            });

      if (resetVisible !== false) {
        visibleCount = mobileInitial();
      }

      if (filterWrap) {
        filterWrap.querySelectorAll('[data-smr-crv-platform]').forEach(function (btn) {
          var active = normalizePlatform(btn.getAttribute('data-smr-crv-platform')) === platform;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      renderVisible();
    }

    function loadData() {
      var jsonUrl = config.jsonUrl;
      var finish = function (jsonReviews) {
        allReviews = mergeReviews(blocks, jsonReviews);
        applyFilter('all', true);
      };

      if (!jsonUrl) {
        finish([]);
        return;
      }

      fetch(jsonUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed');
          return res.json();
        })
        .then(function (payload) {
          finish((payload && payload.reviews) || []);
        })
        .catch(function () {
          finish([]);
        });
    }

    if (filterWrap) {
      filterWrap.addEventListener('click', function (evt) {
        var btn = evt.target.closest('[data-smr-crv-platform]');
        if (!btn) return;
        applyFilter(btn.getAttribute('data-smr-crv-platform'), true);
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        visibleCount += loadBatch;
        renderVisible();
      });
    }

    window.addEventListener('resize', function () {
      if (visibleCount < mobileInitial()) {
        visibleCount = mobileInitial();
        renderVisible();
      }
    });

    loadData();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-smr-customer-reviews]').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-smr-customer-reviews]');
    if (root) initSection(root);
  });
})();
